import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { FormContext } from 'modules/workflows/components/Sidepanel/schemas/nodeSidepanelSchema'

import { createNodeSidepanelSchema } from './nodeSidepanelSchema'

export const createConditionalFormSchema = (formContext: FormContext) => {
  return createNodeSidepanelSchema(formContext).extend({
    nodeType: z.literal('condition'),
    nodeData: z.undefined(),
    comparisons: z
      .array(
        z.object({
          label: z
            .string()
            .min(1, { message: i18n.t('workflows.sidepanel.condition.validation.label_required') }),
          priority: z.number().min(1, {
            message: i18n.t('workflows.sidepanel.condition.validation.priority_min_value'),
          }),
          expression: z.object({
            root: z.object({
              operator: z.enum(['and']),
              expressions: z.array(
                z
                  .object({
                    left: z.object({ name: z.string(), source: z.string() }), //when we add the variable type, we'll be able to restrict the operator options
                    operator: z.enum(['eq', 'neq', 'gt', 'gte', 'lt', 'lte']),
                    right: z.object({
                      value: z.string(),
                      type: z.enum(['boolean', 'float', 'integer', 'nil', 'string']),
                    }),
                  })
                  .refine(
                    (data) => data.right.value.length > 0,
                    (data) => ({
                      message: i18n.t('workflows.sidepanel.condition.validation.value_required', {
                        name:
                          formContext.variableSelectors?.[data.left.name]?.label || data.left.name,
                      }),
                      path: ['right', 'value'],
                    })
                  )
              ),
            }),
          }),
        })
      )
      .min(1, {
        message: i18n.t(
          'workflows.sidepanel.condition.validation.at_least_one_condition_path_required'
        ),
      }),
  })
}

export type ConditionalFormSchema = z.infer<ReturnType<typeof createConditionalFormSchema>>
